/**
 * Contact types
 */

export const AMS_SOURCE_SYSTEM = 'AMS';
export const AA_SOURCE_SYSTEM = 'AUCTION_ACCESS';
export const VICKI_SOURCE_SYSTEM = 'VICKI';
export const SF_SOURCE_SYSTEM = 'SALES_FORCE';
export const CONTACT_SOURCE_SYSTEM = AMS_SOURCE_SYSTEM;
export const SNACKBAR_GENERAL_ERROR_MSG =
  "An error occurred and some changes didn't get saved correctly. Please try again. If the error persists, please enter a SNOW ticket.";
export const SNACKBAR_GENERAL_SUCCESS_MSG = 'Your changes have been saved.';
export const SNACKBAR_REMOVE_RELATION_ERR_MSG =
  'An error occurred and we were unable to remove the relationship. Please try again.';
export const SNACKBAR_SOME_SUCCESS_MSG =
  'Some of your changes have been saved.';
export const SNACKBAR_COULDNT_SAVE_MSG = 'could not be saved.';
export const FETCHING_ERR_MSG =
  'Data could not be loaded. Please refresh the page to try again.';
export const FETCHING_ERR_MSG_DATA =
  'Some data could not be loaded. Please refresh the page to try again.';
export const PERSON_SAME_CONTACTS_INFO_MSG =
  'The following matches were found for the email address and mobile phone entered. Please confirm the individual being created does not already exist. Click ‘Submit’ to proceed with creating the individual.';
export const NO_LINKED_ACCOUNTS = 'There are no linked accounts.';

export const ORG_ALREADY_ASSOCIATED_MSG =
  'This person was already added to the selected organization.';
export const ORG_HAS_NO_SELECT_ROLE_MSG =
  'Sell permission, service permission, and/or post-sale role must be assigned in order to add this relationship.';

export const SNACKBAR_SEARCH_ERROR_MSG =
  'An error occurred. Please try again. If the error persists, please enter a SNOW ticket.';

export const MISSING_APPLICATION_ACCESS_MSG =
  'The registration email cannot be sent. Missing application access.';
export const MISSING_PREFERRED_EMAIL_ADDRESS_MSG =
  'The registration email cannot be sent. Missing preferred email address.';
export const EMAIL_SUCCESSFULLY_MSG = 'The registration email has been sent to';
export const EMAIL_UNSUCCESSFULLY_MSG = (
  <>
    An error occurred while sending registration email. Please try again. If
    error persists, please enter a <b>SNOW</b> ticket.
  </>
);
export const AA_SYNC_DATA_SUCCESSFULLY_MSG =
  'AuctionACCESS Resync was successful. This page will reload in 5 seconds.';
export const AA_SYNC_DATA_UNSUCCESSFULLY_MSG = (
  <>
    An error occurred and AuctionACCESS Resync was not successful. Please try
    again. If the error persists, please enter a <b>SNOW</b> ticket.
  </>
);
export const BRIDGE_ID_IS_UNAVAILABLE = 'Bridge ID is unavailable but account is still linked';

export const TABLE_HEADER_PERSON_SAME_CONTACTS = [
  { id: 'id', value: 'ID' },
  { id: 'lastName', value: 'Last Name' },
  { id: 'firstName', value: 'First Name' },
  { id: 'manheimMail', value: 'Email' },
  { id: 'manheimPhone', value: 'Phone' },
];
export const CONTACT_TYPE_MAIN_PHONE = {
  name: 'Main Phone',
  value: 'MAIN_PHONE',
  primary: false,
  format: 'phone',
};
export const CONTACT_TYPE_FAX = {
  name: 'Fax',
  value: 'FAX',
  primary: false,
  format: 'phone',
};
export const CONTACT_TYPE_CELL = {
  name: 'Cell',
  value: 'CELL',
  primary: false,
  format: 'phone',
};
export const CONTACT_TYPE_TOLL_FREE = {
  name: 'Toll Free',
  value: 'TOLL_FREE',
  primary: false,
  format: 'phone',
};
export const CONTACT_TYPE_ALTERNATE = {
  name: 'Alternate',
  value: 'ALTERNATE',
  primary: false,
  format: 'phone',
};
export const CONTACT_TYPE_EMAIL = {
  name: 'Email',
  value: 'EMAIL',
  primary: false,
  format: 'email',
};
export const CONTACT_TYPE_PRIMARY_MAIN_PHONE = {
  name: 'Main Phone (Primary)',
  value: 'PRIMARY_MAIN_PHONE',
  primary: true,
  format: 'phone',
};
export const CONTACT_TYPE_PRIMARY_CELL = {
  name: 'Cell (Primary)',
  value: 'PRIMARY_CELL',
  primary: true,
  format: 'phone',
};
export const CONTACT_TYPE_PRIMARY_EMAIL = {
  name: 'Email (Primary)',
  value: 'PRIMARY_EMAIL',
  primary: true,
  format: 'email',
};

/**
 * Address Types
 */
export const ADDRESS_TYPE_LOT = {
  name: 'Lot',
  value: 'LOT',
};
export const ADDRESS_TYPE_MAILING = {
  name: 'Mailing',
  value: 'MAILING',
};
export const ADDRESS_TYPE_PAYMENTS = {
  name: 'Payments',
  value: 'PAYMENTS',
};
export const ADDRESS_TYPE_BILLING = {
  name: 'Billing',
  value: 'BILLING',
};
export const ADDRESS_TYPE_PHYSICAL = {
  name: 'Physical',
  value: 'PHYSICAL',
};

export const ORG_PHONE_PRIORITY = {
  [CONTACT_TYPE_PRIMARY_MAIN_PHONE.value]: 0,
  [CONTACT_TYPE_PRIMARY_CELL.value]: 1,
  [CONTACT_TYPE_MAIN_PHONE.value]: 2,
  [CONTACT_TYPE_CELL.value]: 3,
};

export const PERSON_PHONE_PRIORITY = {
  [CONTACT_TYPE_PRIMARY_CELL.value]: 0,
  [CONTACT_TYPE_PRIMARY_MAIN_PHONE.value]: 1,
  [CONTACT_TYPE_CELL.value]: 2,
  [CONTACT_TYPE_MAIN_PHONE.value]: 3,
};

export const ORG_EMAIL_PRIORITY = {
  [CONTACT_TYPE_PRIMARY_EMAIL.value]: 0,
  [CONTACT_TYPE_EMAIL.value]: 1,
};

export const PERSON_EMAIL_PRIORITY = {
  [CONTACT_TYPE_PRIMARY_EMAIL.value]: 0,
  [CONTACT_TYPE_EMAIL.value]: 1,
};

export const EMAIL_FORM_KEY = 'emails';
export const PHONE_FORM_KEY = 'phones';

export const PERSON_PRIMARY_PHONE = 'PRIMARY_CELL';
export const PERSON_PRIMARY_EMAIL = 'PRIMARY_EMAIL';
export const PERSON_NEW_MAIL_TYPE = 'EMAIL';
export const PERSON_NEW_PHONE_TYPE = 'CELL';

export const ORG_PRIMARY_PHONE = 'PRIMARY_MAIN_PHONE';
export const ORG_PRIMARY_EMAIL = 'PRIMARY_EMAIL';
export const ORG_NEW_MAIL_TYPE = 'EMAIL';
export const ORG_NEW_PHONE_TYPE = 'MAIN_PHONE';

export const PREFERRED_PHONE = 'PREFERRED_PHONE';
export const PREFERRED_EMAIL = 'PREFERRED_EMAIL';

export const PHONE_CHANNEL = 'phone';
export const EMAIL_CHANNEL = 'email';

/**
 * Details component constants
 * used to track editing state
 * of different components
 */

export const HERO_VIEW = 'HERO_VIEW';
export const HERO_EDIT = 'HERO_EDIT';

/**
 * representatives and permissions
 */

export const POST_SALE_KEY = 'postSaleRole';
export const DENY_ID = 'DENY_ID';
/**
 * Groups to decide user can view/edit detail page
 */

export const LOOKER_GROUP = 'ManheimApiOauth-AccountManagementService_Looker';
export const ADMIN_GROUP = 'ManheimApiOauth-AccountManagementService_Admin';
export const TIER2_GROUP = 'ManheimApiOauth-AccountManagementService_CCTier2';
export const EDIT_GROUP = 'ManheimApiOauth-AccountManagementService_CCEdit';
export const CIMANAGER_GROUP = 'ManheimApiOauth-AccountManagementService_CIManager';

export const TOTAL_PERSON_PROFILE_FIELDS = 6;
export const TOTAL_PERSON_PROFILE_FIELDS_AA = 2;

/**
 * Max length same with fields in AMS database
 */
export const MAX_LENGTH_FIRST_NAME = 150;
export const MAX_LENGTH_LAST_NAME = 150;
export const MAX_LENGTH_EMAIL = 100;

/**
 * Validation messages
 */
export const COX_MAIL_ERROR_MSG = 'Invalid email address';
export const COX_PHONE_ERROR_MSG = 'Invalid phone number';

/**
 * Online role
 */
export const APP_PERM_MANHEIM = 'Manheim_com';
export const APP_PERM_OVE = 'OVE_com';
export const APP_PERM_SIMULCAST = 'Simulcast';
export const APP_PERM_FORDQUIC = 'FordQUIC';
export const APP_PERM_HYUNDAI = 'Hyundai';
export const APP_PERM_AUDI = 'Audi_Direct';
export const APP_PERM_CARVANA = 'Carvana';
export const APP_PERM_MERCEDES = 'Mercedes_Benz';
export const APP_PERM_TOYOTAFS = 'Toyota_FS';
export const APP_PERM_ELEMENT = 'Element';
export const APP_PERM_VCNA = 'VCNA';
export const APP_PERM_NISSAN = 'Nissan_RPM';
export const APP_PERM_VCI = 'VCI';
export const APP_PERM_VW = 'VW_Direct';
export const APP_PERM_BGD = 'BGD';
export const APP_PERM_KIA = 'Kia';

/**
 * Error in individual creation
 */
export const ERROR_PERSON_CREATION_MAIL_KEY = 'mailAMSError';
export const ERROR_PERSON_CREATION_MAIL_ASSOCIATION_KEY =
  'mailAMSAssociationError';
export const ERROR_PERSON_CREATION_PHONE_KEY = 'phoneAMSError';
export const ERROR_PERSON_CREATION_PHONE_ASSOCIATION_KEY =
  'phoneAMSAssociationError';
export const ERROR_PERSON_CREATION_PREFERRED_MAIL_KEY = 'preferredMailAMSError';
export const ERROR_PERSON_CREATION_PREFERRED_MAIL_ASSOCIATION_KEY =
  'preferredMailAMSAssociationError';
export const ERROR_PERSON_CREATION_PREFERRED_PHONE_KEY = 'preferredPhoneAMSError';
export const ERROR_PERSON_CREATION_PREFERRED_PHONE_ASSOCIATION_KEY =
  'preferredPhoneAMSAssociationError';
export const ERROR_PERSON_CREATION_ONLINE_ROLE_KEY = 'onlineRoleAMSError';

export const ADD_ORGS_LOADING_TEXT = 'Adding Account to Organizations...';
export const SEARCH_ACTIVE_ORGS_LOADING_TEXT = 'Search results loading...';
export const ADD_ORGS_SUCCESS_SNACKBAR_MSG =
  'The organizations you selected were added.';
export const ORGANIZATIONS_ADDED_LABEL = 'Organizations Added';
export const ORGANIZATIONS_NOT_ADDED_LABEL = 'Organizations Not Added';

// Tooltips
export const NO_UPDATES_DETECTED = 'No updates detected';
export const INVALID_Fields = 'Invalid fields';
